import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import NoteModal from '../modals/NoteModal';
import { editNewExerciseNote } from '../../store';
import AddExerciseModal from '../modals/AddExerciseModal';

const ExerciseItem = ({ exercise, index, length, onRemove, onExerciseMoveUp, onExerciseMoveDown, onSwitchExercise, onClickSuperset, onRemoveExerciseFromSuperset }) => {
  const [openModalNote, setOpenModalNote] = useState(false);
  const [modalNoteData, setModalNoteData] = useState('');
  const dispatch = useDispatch();

  const onAddNotes = (exercise) =>{
    setModalNoteData((exercise.note === null || exercise.note === undefined)? '': exercise.note);
    setOpenModalNote(true);
  }
  const onSaveNote = (exerciseKey,note) =>{
    dispatch(editNewExerciseNote({exerciseKey, note}));
    handleCloseModalNote();
  }
  const handleCloseModalNote = () => {
    setOpenModalNote(false);
    setModalNoteData('');  // Resetea el contenido
  }

  const [openModalSwitchEx, setOpenModalSwitchEx] = useState(false);
  const switchExercise = () => {
    setOpenModalSwitchEx(true);
  }
  const handleSwitchExercise = (selectedExercise) => {
    onSwitchExercise(selectedExercise, exercise);
    setOpenModalSwitchEx(false);
  }

  return (
    <div
      className={`${exercise.superset ? 'border-l '+generateColor(exercise.superset) :'border-b border-gray-100'} hover:bg-gray-50 group`}
    >
      <div className="p-3 h-full flex justify-between items-start">
        <div className="flex-1 min-w-0">
          <h4 className="text-xs font-medium text-gray-900 truncate mb-2">
            {exercise.name}
          </h4>
          <p className="text-xs text-gray-500">
            <button
              onClick={() => onAddNotes && onAddNotes(exercise)}
              className="p-1 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-all"
              title="Add notes"
            >
              Notes
            </button>
          </p>
          <p className="text-xs text-gray-400">
            <button
              onClick={() => switchExercise(exercise)}
              className="p-1 text-gray-400 hover:text-orange-600 hover:bg-orange-50 rounded transition-all"
              title="Add notes"
            >
              Switch Exercise
            </button>
            
          </p>
          <p className="text-xs text-gray-400">
            {index + 1 < length && (<button
              onClick={() => onClickSuperset(exercise)}
              className="p-1 text-gray-400 hover:text-green-600 hover:bg-green-50 rounded transition-all"
              title="Add notes"
            >
              Superset with next
            </button>)}
          </p>
          <p className="text-xs text-gray-400">
            {exercise.superset && (<button
              onClick={() => onRemoveExerciseFromSuperset(exercise)}
              className="p-1 text-gray-400 hover:text-green-600 hover:bg-green-50 rounded transition-all"
              title="Add notes"
            >
              Remove from superset
            </button>)}
          </p>
        </div>
        {index > 0 && (
        <button
          onClick={() => onExerciseMoveUp(exercise.id, exercise.key)}
          className="ml-2 p-1 rounded text-gray-400 hover:text-[rgb(79,70,229)] hover:bg-indigo-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
          title="Mover arriba"
        >
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
          </svg>
        </button>
        )}
        {index + 1 < length && (
        <button
          onClick={() => onExerciseMoveDown(exercise.id, exercise.key)}
          className="ml-2 p-1 rounded text-gray-400 hover:text-[rgb(79,70,229)] hover:bg-indigo-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
          title="Mover abajo"
        >
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        )}
        <button
          onClick={() => onRemove(exercise.id, exercise.key)}
          className="ml-2 p-1 rounded text-gray-400 hover:text-red-500 hover:bg-red-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
          title="Eliminar ejercicio"
        >
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <NoteModal open={openModalNote} itemKey={exercise.key} setOpen={setOpenModalNote} initialNote={modalNoteData} onSave={onSaveNote}/>
      <AddExerciseModal open={openModalSwitchEx} setOpen={setOpenModalSwitchEx} onAddExercise={handleSwitchExercise}/>
    </div>
  );
};

function generateColor(str) {
  // Generar un valor hash a partir del string
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  // Convertir el hash en un valor entre 0 y 255
  let value = hash & 0xFF;
  
  // Generar una clase de Tailwind basada en el valor
  let tailwindColors = [
      'border-red-500', 
      'border-orange-500', 
      'border-amber-500', 
      'border-yellow-500', 
      'border-lime-500', 
      'border-green-500',
      'border-emerald-500', 
      'border-teal-500',
      'border-cyan-500',
      'border-sky-500',
      'border-blue-500', 
      'border-indigo-500', 
      'border-violet-500',
      'border-purple-500', 
      'border-fuchsia-500', 
      'border-pink-500',
      'border-rose-500',
      'border-fuchsia-500',
  ];
  
  // Seleccionar una clase de color de Tailwind
  let tailwindClass = tailwindColors[value % tailwindColors.length];
  
  return tailwindClass;
}

export default ExerciseItem;
